// extracted by mini-css-extract-plugin
export default {"iframe":"VideoAnswer_iframe__1QEWX","modal":"VideoAnswer_modal__U45ZN"};